import { useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import { getFormValues } from 'redux-form';

import AccessCardBatchFormComponent from './AccessCardBatchFormComponent';

import { getBuildingsForFilter } from '../Building/actionCreators';
import { createAccessCard, getAccessCard, updateAccessCard } from './actions';

import { srtSeparateToArray } from '../Unit/utils';
import { getPMCsFromBuildings } from './utils';

const form = 'accessCardBatch';

const AccessCardBatchFormContainer = (props) => {
  const { selectedType, onGetBuildingsForFilter } = props;

  const isLyazonType = selectedType === 'lyazon';

  useEffect(() => {
    if (selectedType) {
      isLyazonType
        ? onGetBuildingsForFilter({
            associatedWithLyazon: true,
          })
        : onGetBuildingsForFilter({
            associatedWithTwoN: true,
          });
    }
  }, [selectedType]);

  return (
    <AccessCardBatchFormComponent
      isLyazonType={isLyazonType}
      selectedType={selectedType}
      {...props}
    />
  );
};

const mapStateToProps = (state, ownProps) => {
  const accessCardBatchId = ownProps?.match?.params?.id;
  const {
    accessCards: { card: batch },
    buildings,
  } = state;
  const initialValues = {
    ...batch,
  };
  const isCreate = Number.isNaN(Number(accessCardBatchId));
  const buildingsArray = buildings ? Object.values(buildings) : [];
  const property = [...getPMCsFromBuildings(buildingsArray), ...buildingsArray];
  const formValues = getFormValues(form)(state);
  const selectedType = formValues?.type;
  return {
    form,
    initialValues,
    isCreate,
    property,
    selectedType,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const accessCardBatchId = ownProps?.match?.params?.id;
  const isCreate = accessCardBatchId === 'create';
  return {
    onLoad: () => {
      !isCreate &&
        accessCardBatchId &&
        getAccessCard(dispatch, accessCardBatchId, true);
      isCreate &&
        getBuildingsForFilter(dispatch, {
          associatedWithLyazon: true,
          associatedWithTwoN: true,
        });
    },
    onGetBuildingsForFilter: (params) =>
      getBuildingsForFilter(dispatch, params),
    onSubmit: (data) => {
      const { id, cardNumbersList } = data;
      const updatedData = {
        ...data,
        cardNumbersList: srtSeparateToArray(cardNumbersList),
      };
      return id
        ? updateAccessCard(dispatch, id, updatedData, true)
        : createAccessCard(dispatch, updatedData, true);
    },
  };
};

AccessCardBatchFormContainer.defaultProps = {
  selectedType: null,
};
AccessCardBatchFormContainer.propTypes = {
  selectedType: PropTypes.string,
  onGetBuildingsForFilter: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AccessCardBatchFormContainer);
